const SET_FREQUENCY_PARAMS = 'efes/paymentFrequency/SET_FREQUENCY_PARAMS';
const SET_SHOW_SECTION = 'efes/paymentFrequency/SET_SHOW_SECTION';
const SET_SUBMIT_BUTTON = 'efes/paymentFrequency/SET_SUBMIT_BUTTON';
const SET_FREQUENCY_CHANGE_LISTENER = 'efes/paymentFrequency/SET_FREQUENCY_CHANGE_LISTENER';

const initialState = {
  params: {
    type: '',
    plan: '',
    basePrice: 0,
    hidePrice: false,
    isFetchingPrice: false,
    additionalPrice: 0,
    hasDiscount: false,
    discount: 0,
    finalPrice: 0,
    paymentFrequencyPrices: [],
    paymentFrequency: {},
    paymentFrequenciesOption: {},
    hasAdditionalCoverages: false,
    priceSectionOptions: {
      basePrice: {
        translation: '',
        showPrice: true,
      },
      finalPrice: {
        translation: '',
        showPrice: true,
      },
      overallPrice: {
        translation: '',
        showPrice: true,
      },
    },
  },
  showSection: false,
  submitButton: false,
  paymentFrequencyChangeListener: {
    action: '',
    dispatch: () => {},
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_FREQUENCY_PARAMS:
      return {
        ...state,
        params: {
          ...state.params,
          ...action.data,
        },
      };
    case SET_SHOW_SECTION:
      return {
        ...state,
        showSection: action.data,
      };
    case SET_SUBMIT_BUTTON:
      return {
        ...state,
        submitButton: action.data,
      };
    case SET_FREQUENCY_CHANGE_LISTENER:
      return {
        ...state,
        paymentFrequencyChangeListener: action.data,
      };
    default:
      return state;
  }
}

export const setPaymentFrequencyParams = (data) => ({
  type: SET_FREQUENCY_PARAMS,
  data,
});

export const setPaymentFrequencyChangeListener = (data) => ({
  type: SET_FREQUENCY_CHANGE_LISTENER,
  data,
});

export const setShowPaymentFrequencyPrice = (data) => ({
  type: SET_SHOW_SECTION,
  data,
});

export const setSubmitPaymentFrequencyPriceButton = (data) => ({
  type: SET_SUBMIT_BUTTON,
  data,
});
